import React from "react";
import { Typography, IconButton } from "@mui/material";
import {
  MdOutlineSentimentSatisfied,
  MdOutlineSentimentNeutral,
  MdOutlineSentimentDissatisfied,
} from "react-icons/md";
import { CenteredModal, CommentWrapper, CustomTextField, FeedbackIconWrapper, FeedbackModalContent, SearchButton } from "./FAQSearch.style";
import VoiceButton from "../voice/voiceButton";

const SessionFeedbackBox = ({
  sessionFeedbackChoice,
  sessionFeedbackComment,
  setSessionFeedbackComment,
  handleSessionFeedback,
  submitSessionFeedback,
  primaryColor,
  open,
  onClose,  
}) => {
  // Helper function to submit with a specific comment value
  const handleSubmitWithComment = (comment) => {
    submitSessionFeedback(comment);
  };

  return (
    <CenteredModal
      open={open}
      onClose={onClose}
      aria-labelledby="session-feedback-modal"
    >
      <FeedbackModalContent>
        <Typography variant="subtitle1">
          How was your experience?
        </Typography>

        {!sessionFeedbackChoice && (
          <FeedbackIconWrapper>
            <IconButton onClick={() => handleSessionFeedback('happy')}>
              <MdOutlineSentimentSatisfied color={primaryColor} size={32} />
            </IconButton>
            <IconButton onClick={() => handleSessionFeedback('neutral')}>
              <MdOutlineSentimentNeutral color={primaryColor} size={32} />
            </IconButton>
            <IconButton onClick={() => handleSessionFeedback('sad')}>
              <MdOutlineSentimentDissatisfied color={primaryColor} size={32} />
            </IconButton>
          </FeedbackIconWrapper>
        )}

        {(sessionFeedbackChoice === 'sad' || sessionFeedbackChoice === 'neutral') && (
            <CommentWrapper>
              <CustomTextField
                fullWidth
                value={sessionFeedbackComment}
                onChange={(e) => setSessionFeedbackComment(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSubmitWithComment(sessionFeedbackComment);
                  }
                }}
                placeholder={"Type your short feedback here..."}
              />
            
              <VoiceButton onTranscript={(text) => {
                setSessionFeedbackComment(text);
              }} />
              <SearchButton
                onClick={() => {
                  handleSubmitWithComment(sessionFeedbackComment);
                }}
              >
                <Typography fontSize="10px">{'Submit'}</Typography>
              </SearchButton>
            </CommentWrapper>
        )}

        {sessionFeedbackChoice === 'happy' && (
          <Typography variant="caption" >
            Thanks for your feedback!
          </Typography>
        )}
      </FeedbackModalContent>
    </CenteredModal>
  );
};

export default SessionFeedbackBox;